import React, { memo } from 'react';
import { CheckIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function PricingSection() {
  const features = ['Accesso immediato via app o web, da qualsiasi dispositivo, con login semplice e sicuro', 'Programma guidato di 8 settimane, con piano giorno-per-giorno e progressione personalizzata', 'Allenamenti mentali quotidiani per memoria, concentrazione e attenzione', 'PDF, esercizi pratici, checklist e diario della mente, per misurare i tuoi progressi', 'Consigli nutrizionali mediterranei, basati su ricerche europee sul benessere cerebrale', 'Rituali di benessere e rilassamento, per migliorare sonno, calma e lucidità', 'Sezione "Riflessioni & Obiettivi", per consolidare le abitudini e la motivazione', 'Tracciamento dei risultati, con feedback automatico e suggerimenti di miglioramento', 'Accesso a vita, senza abbonamenti o costi nascosti', 'Garanzia 7 giorni Soddisfatti o Rimborsati, senza domande'];
  const handlePurchase = () => {
    // Track InitiateCheckout event with Meta Pixel
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout');
    }
    window.location.href = 'https://pessoa-co.mycartpanda.com/checkout/199392781:1';
  };
  return <section id="prezzo" className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-185">
      <div className="max-w-4xl mx-auto" data-id="element-186">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-12 text-center" data-id="element-187">
          Il tuo percorso personalizzato è pronto per iniziare oggi
        </h2>
        <div className="bg-gradient-to-br from-green-50 to-blue-50 p-8 sm:p-12 rounded-2xl shadow-2xl border-2 border-green-600" data-id="element-188">
          <div className="text-center mb-8" data-id="element-189">
            <p className="text-xl text-gray-600 mb-2" data-id="element-190">Prezzo originale</p>
            <p className="text-3xl text-gray-400 line-through mb-4" data-id="element-191">€54,90</p>
            <p className="text-6xl sm:text-7xl font-bold text-green-600 mb-2" data-id="element-192">
              €17
            </p>
            <p className="text-2xl text-green-700 font-semibold mb-4" data-id="element-193">(–69%)</p>
            <p className="text-lg text-gray-700" data-id="element-194">
              Meno di €0,60 al giorno per una mente più lucida e serena.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg mb-8" data-id="element-195">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-196">
              Cosa include:
            </h3>
            <ul className="space-y-3" data-id="element-197">
              {features.map((feature, index) => <li key={index} className="flex items-start text-lg text-gray-700" data-id="element-198">
                  <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-199" />
                  <span data-id="element-200">{feature}</span>
                </li>)}
            </ul>
          </div>
          <button onClick={handlePurchase} className="w-full bg-green-600 hover:bg-green-700 text-white text-2xl sm:text-3xl font-bold py-6 rounded-lg transition-all transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-green-500 focus:ring-offset-2 shadow-lg mb-6" aria-label="Ottieni l'accesso al programma" data-id="element-201">
            Ottieni l'accesso al programma
          </button>
          <CountdownTimer data-id="element-202" />
          <p className="text-center text-base text-gray-600 mt-6" data-id="element-203">
            Pagamento sicuro. Nessuna iscrizione ricorrente.
          </p>
        </div>
      </div>
    </section>;
}